module.exports = __webpack_public_path__ + "img/target.a5b2d0e6.svg";